const toast = useToast();

export function timeout(ms: number, message?: string, throwError?: boolean) {
  return new Promise<void>((resolve, reject) => {
    setTimeout(() => {
      if (throwError) reject(new Error(message));
      else resolve();
    }, ms);
  });
}

export function debounce(func: Function, delay: number) {
  let timeoutId: number
  return (...args: any[]) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => func.apply(null, args), delay)
  }
}

export function showError(message: string) {
  toast.add({
    title: 'Error',
    description: message,
    icon: 'i-lucide-x',
    color: 'error'
  })
}

export function showWarning(message: string) {
  toast.add({
    title: 'Warning',
    description: message,
    icon: 'i-lucide-triangle-alert',
    color: 'warning'
  });
}

export function showSuccess(message: string) {
  toast.add({
    title: 'Success',
    description: message,
    icon: 'i-lucide-check',
    color: 'success'
  });
}

export function showValidationErrors(error: any, t: (key: string) => string) {
  const errorData = error?.response?.data;

  if (!errorData) {
    showError(t('error.loadingData'));
    return;
  }
  
  if (errorData.errors && typeof errorData.errors === 'object') {
    Object.entries(errorData.errors).forEach(([field, messages]) => {
      if (Array.isArray(messages)) {
        messages.forEach(message => {
          if (typeof message === 'string') {
            showError(message);
          } else if (message?.errorMessage) {
            showError(message.errorMessage);
          }
        });
      }
    });
  } else if (errorData.title || errorData.detail) {
    showError(errorData.title || errorData.detail);
  } else {
    showError(t('error.loadingData'));
  }
}